import React from 'react';
import { CustomInput } from './CustomInput';
import PhoneInput from 'react-phone-number-input/input';
import { CustomInputChangeEvent } from '../../../utils/models/events/CustomInputChangeEvent';

interface CustomPhoneInputProps {
  placeholder?: string;
  name: string;
  onChange: (event: CustomInputChangeEvent) => void;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
  value: string;
  disabled: boolean;
  className?: string;
}

export function CustomPhoneInput({ onChange, onBlur, name, value, placeholder, disabled, className }: CustomPhoneInputProps) {
  function emitEvent(x: unknown) {
    onChange({
      target: {
        name: name,
        type: 'phone-input',
        // @ts-ignore
        value: x ? x.toString() : ''
      }
    });
  }

  return <PhoneInput
    placeholder={placeholder}
    name={name}
    value={value}
    inputComponent={CustomInput}
    onChange={emitEvent}
    onBlur={onBlur}
    smartCaret={true}
    className={className}
    disabled={disabled} />;
}
